import { useMonitoringLive, useMonitoringMetrics } from "../api";
import { RequestCharts } from "./requests/request-charts";
import { RequestTail } from "./requests/request-tail";
import { RouteTable } from "./requests/route-table";
import { SlowRequests } from "./requests/slow-requests";
import { LiveTraffic, WindowTraffic } from "./requests/traffic-tiles";

/**
 * Requests: what the API is answering right now (this instance's request ring), the board window from the
 * persisted metrics (volume by status class, latency, concurrency, per-route table) and the slow / latest
 * requests, so a stuck or misbehaving backend shows up at a glance.
 */
export function RequestsTab() {
  const live = useMonitoringLive();
  const metrics = useMonitoringMetrics();
  return (
    <div className="flex min-w-0 flex-col gap-4">
      <LiveTraffic live={live} />
      <WindowTraffic metrics={metrics} />
      <RequestCharts metrics={metrics} />
      <RouteTable metrics={metrics} />
      <SlowRequests live={live} />
      <RequestTail live={live} />
    </div>
  );
}
